import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// utils
import localStorageAvailable from '../utils/localStorageAvailable';
//
import { defaultLang } from './config-lang';
//
import BackEnd from "i18next-http-backend"
import enLocales from './langs/en/translations.json';
import arLocales from './langs/ar/translations.json';
import enCartLocales from './langs/en/cart.json';
import arCartLocales from './langs/ar/cart.json';
import enHomeLocales from './langs/en/home.json';
import arHomeLocales from './langs/ar/home.json';
import enWishlistLocales from './langs/en/wishlist.json';
import arWishlistLocales from './langs/ar/wishlist.json';
import enProfileLocales from './langs/en/profile.json';
import arProfileLocales from './langs/ar/profile.json';
import enOrderLocales from './langs/en/order.json';
import arOrderLocales from './langs/ar/order.json';

// ----------------------------------------------------------------------

let lng = defaultLang.value;

const storageAvailable = localStorageAvailable();

if (storageAvailable) {
  lng = localStorage.getItem('i18nextLng') || defaultLang.value;
}

i18n
  .use(LanguageDetector)
  .use(BackEnd)
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        translations: enLocales,
        cart: enCartLocales,
        home: enHomeLocales,
        wishlist: enWishlistLocales,
        profile: enProfileLocales,
        order: enOrderLocales,
      },
      ar: { 
        translations: arLocales,
        cart: arCartLocales,
        home: arHomeLocales,
        wishlist: arWishlistLocales,
        profile: arProfileLocales,
        order: arOrderLocales,
      },
    },
    lng,
    fallbackLng: defaultLang.value,
    ns: ['translations', 'cart', 'home', 'wishlist', 'profile', 'order'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "localStorage", "htmlTag", "cookie", "subdomain"],
      caches: ["localStorage", "cookie"],
    },
    debug: false,
    saveMissing: true,
    backend: {
      loadPath: '/locales/langs/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
